/**
 * @generated SignedSource<<27458c5792dac71c912517a39e7a3f82>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutACHForm_buyer$data = {
  readonly isTrade: boolean | null;
  readonly wallet: {
    readonly paymentMethods: ReadonlyArray<{
      readonly paymentMethod: {
        readonly accountType?: string | null;
        readonly last4?: string | null;
        readonly routingNumber?: string | null;
        readonly token?: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutEoriVatForm_buyer">;
  readonly " $fragmentType": "CheckoutACHForm_buyer";
};
export type CheckoutACHForm_buyer$key = {
  readonly " $data"?: CheckoutACHForm_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutACHForm_buyer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutACHForm_buyer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutEoriVatForm_buyer"
    },
    {
      "alias": "isTrade",
      "args": null,
      "kind": "ScalarField",
      "name": "isVerifiedTrade",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Wallet",
      "kind": "LinkedField",
      "name": "wallet",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "WalletPaymentMethod",
          "kind": "LinkedField",
          "name": "paymentMethods",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "paymentMethod",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "token",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "last4",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "accountType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "routingNumber",
                      "storageKey": null
                    }
                  ],
                  "type": "ACH",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "90908cf5b21fc1154226347dcbe7f7d8";

export default node;
